import React from 'react';
import { Navigate } from 'react-router';
import { useRolePermissions } from '@rfacil/shared/hooks';
import { canOpenMaterialidadModule } from '../permissions/materialidad-module-access';

interface MaterialidadRouteGuardProps {
  /**
   * Contenido a mostrar si el usuario puede abrir el módulo
   */
  children: React.ReactNode;
}

/**
 * @component MaterialidadRouteGuard
 * @description Protege `/materialidad/*` con `canOpenMaterialidadModule`, la misma
 * regla con la que el menú lateral y el tablero ofrecen el módulo. Así un usuario
 * que ve el módulo no es expulsado al entrar (por ejemplo, un Operativo con la
 * acción `VerFacturas` pero sin la sección `ListadoFacturas`).
 * Igual que `PermissionRouteGuard`, redirige a `/` cuando no hay acceso.
 * @param {MaterialidadRouteGuardProps} props Las propiedades del componente.
 * @returns {React.ReactElement} El contenido protegido o la redirección.
 */
export const MaterialidadRouteGuard: React.FC<MaterialidadRouteGuardProps> = ({
  children,
}) => {
  const permisos = useRolePermissions();

  if (!canOpenMaterialidadModule(permisos)) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default MaterialidadRouteGuard;
